import { useContext } from "react";

import { UniversalBenchmarksContext } from "../context";

export const useAdoptedBenchmark = () => {
  const context = useContext(UniversalBenchmarksContext);

  if (!context) {
    throw new Error(
      "useAdoptedBenchmark can only be used inside UniversalBenchmarksContext",
    );
  }

  return context.adoptedBenchmark;
};
